import { Link } from "react-router-dom"
import { config } from "../lib/config"
import { hasActiveSession } from "../lib/auth"

const navItems = [
  { to: "/desenvolvedores", label: "Documentação", external: false as const },
  { href: "#recursos", label: "Recursos", external: true as const },
  { href: "#vantagens", label: "Vantagens", external: true as const },
  { href: "#como-funciona", label: "Como funciona", external: true as const },
  { href: "#faq", label: "FAQ", external: true as const },
]

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-2" aria-label={`${config.appName} início`}>
          <img src="/assets/brand/logo-horizontal.svg" alt="" className="h-8 w-auto" />
          <span className="text-lg font-semibold text-slate-900">{config.appName}</span>
        </Link>

        <nav className="hidden items-center gap-6 md:flex" aria-label="Principal">
          {navItems.map((item) =>
            item.external ? (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-slate-600 transition hover:text-brand-600"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.to}
                to={item.to!}
                className="text-sm font-medium text-slate-600 transition hover:text-brand-600"
              >
                {item.label}
              </Link>
            ),
          )}
        </nav>

        <div className="flex items-center gap-2">
          {hasActiveSession() ? (
            <Link
              to="/app"
              className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-700"
            >
              Acessar painel
            </Link>
          ) : (
            <Link
              to="/login?return=/app"
              className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
            >
              Entrar
            </Link>
          )}
        </div>
      </div>
    </header>
  )
}
